<template>
    <div class="bind-kin">
      <!-- 标题 -->
      <h1>分享亲属</h1>
      <!-- 表单输入 -->
      <div class="input-item">
        <label for="phone">手机号</label>
        <input id="phone" v-model="formData.phone" placeholder="请输入手机号" />
      </div>
      <div class="input-item">
        <label for="name">姓名</label>
        <input id="name" v-model="formData.name" placeholder="请输入姓名" />
      </div>
      <!-- 操作按钮 -->
      <div class="action-btns">
        <button @click="handleBack">返回</button>
        <button @click="handleConfirm">确认</button>
      </div>
      <!-- 操作说明 -->
      <div class="operation-tips">
        <p>操作说明：</p><br/>
        <ol>
          <li>请微信分享，亲属点击分享链接并登录后使用</li>
          <li>输入亲属手机号和姓名</li>
          <li>亲属使用上方输入手机号登录</li>
          <li>预约信息将同步到亲属的账号，可同时视频</li>
          <li>登录成功后点击“我的预约”--"亲属"，可查看预约订单</li>
        </ol>
      </div>
    </div>
  </template>
  
  <script>
  import { bindKin } from '@/api/orderBindApi'
  import { getKey } from '@/common/js/cache'
  export default {
    data() {
      return {
        // 表单输入数据
        formData: {
          phone: '',
          name: ''
        }
      };
    },
    methods: {
      // 检查当前页面是否被iframe嵌套（防止点击劫持）
      isPageInIframe() {
        try {
          return window.self !== window.top;
        } catch (e) {
          // 如果出现异常，说明处于iframe中
          return true;
        }
      },
      isValidUrl(url) {
        try {
          const parsedUrl = new URL(url);
          
          // 1. 检查协议是否安全
          if (!['https:', 'http:'].includes(parsedUrl.protocol)) {
            console.warn('不安全的协议:', parsedUrl.protocol);
            return false;
          }
          
          // 2. 检查是否在预设的可信域名白名单中
          const allowedDomains = [
            'wx.warmdoctor.com',
            'warmdoctor.com',
            'localhost',
            '127.0.0.1'
          ];
          
          // 严格匹配主机名（包括子域名）
          const hostname = parsedUrl.hostname.toLowerCase();
          const isAllowed = allowedDomains.some(domain => {
            // 完全匹配或子域名匹配
            return hostname === domain || hostname.endsWith('.' + domain);
          });
          
          if (!isAllowed) {
            console.warn('域名不在白名单中:', hostname);
            return false;
          }
          
          // 3. 检查端口是否安全（如果不是标准端口，额外验证）
          const allowedPorts = ['', '80', '443', '8080', '3000', '8000'];
          if (!allowedPorts.includes(parsedUrl.port)) {
            console.warn('非标准端口:', parsedUrl.port);
            return false;
          }
          
          return true;
        } catch (e) {
          console.error('URL格式错误:', e);
          return false;
        }
      },
      // 防止开放重定向攻击的安全跳转
      safeRedirect(url) {
        // 首先验证URL
        if (!this.isValidUrl(url)) {
          console.error('无效或不安全的URL:', url);
          this.$createDialog({
            type: 'alert',
            title: '错误',
            content: '无法打开不安全的链接',
            confirmBtn: {
              text: '确定',
              active: true,
              disabled: false
            }
          }).show();
          return;
        }

        // 防止开放重定向攻击
        const cleanUrl = this.sanitizeUrl(url);

        // 检查是否在iframe中（防止点击劫持）
        if (this.isPageInIframe()) {
          console.warn('页面被嵌入iframe中');
          // 可以尝试跳出iframe，但这可能不总是有效
          if (window.top) {
            window.top.location.href = cleanUrl;
          } else {
            window.location.href = cleanUrl;
          }
        } else {
          // 防止目标页面访问原始窗口对象
          //window.open(cleanUrl, '_blank', 'noopener,noreferrer,menubar=no,toolbar=no,location=no');
          window.location.replace(cleanUrl);
        }
      },
      // 清理URL，移除潜在危险参数
      sanitizeUrl(url) {
        try {
          const urlObj = new URL(url);
          
          // 移除可能包含恶意脚本的参数（如回调函数、redirect等）
          const potentiallyDangerousParams = [
            'callback', 'redirect', 'return_url', 'returnUrl', 
            'url', 'next', 'data', 'load'
          ];
          
          potentiallyDangerousParams.forEach(param => {
            if (urlObj.searchParams.has(param)) {
              const paramValue = urlObj.searchParams.get(param);
              // 检查参数值是否包含潜在的恶意内容
              if (paramValue && (
                paramValue.toLowerCase().includes('javascript:') ||
                paramValue.toLowerCase().includes('data:') ||
                paramValue.toLowerCase().includes('<script')
              )) {
                console.warn(`发现潜在危险参数 ${param}:`, paramValue);
                urlObj.searchParams.delete(param);
              }
            }
          });
          
          return urlObj.toString();
        } catch (e) {
          console.error('URL清理失败:', e);
          return url;
        }
      },
      handleBack() {
        this.$router.replace({
          path: '/orderlist'
        })
      },
     async handleConfirm() {
      if (!this.formData.phone || !this.formData.name) {
        this.$createDialog({
          type: 'alert',
          title: '提示',
          content: '请填写完整信息'
        }).show()
        return;
      } 
        const orderId = this.$route.query.orderId
        const params = {
          phone: this.formData.phone,
          name: this.formData.name,
          orderId: orderId
        } 
        await bindKin(params).then(res => {
          if (res.code === '9000200') {
            //镁信绑定完后分享微信
            if(getKey() === '~a01akcbbc7aaao'){
                this.$createDialog({
                  type: 'alert',
                  title: '提示',
                  content: '绑定成功',
                  confirmBtn: {
                    text: '微信分享',
                    active: true,
                    disabled: false,
                    href: 'javascript:void(0)'
                  },
                  onConfirm: () => {
                   this.safeRedirect('https://wx.warmdoctor.com/orderShare.html?_t=' + new Date().getTime());
                  }
              }).show()
            }else{
                this.$createDialog({
                  type: 'alert',
                  title: '提示',
                  content: '绑定成功'
                }).show()
            }
          } else {
            //镁信绑定完后分享微信
            if(getKey() === '~a01akcbbc7aaao'){
                this.$createDialog({
                  type: 'alert',
                  title: '提示',
                  content: '绑定成功',
                  confirmBtn: {
                    text: '微信分享',
                    active: true,
                    disabled: false,
                    href: 'javascript:void(0)'
                  },
                  onConfirm: () => {
                    this.safeRedirect('https://wx.warmdoctor.com/orderShare.html?_t=' + new Date().getTime());
                  }
              }).show()
            }else{
              this.$createDialog({
                type: 'alert',
                title: '绑定失败',
                content: res.message
              }).show()
            }
           
          }
        })
      }
    }
  };
  </script>
<style lang="css" scoped>
.bind-kin {
  color: #fff;
  padding: 20px;
  font-family: 'Arial', sans-serif;
}

h1 {
  text-align: center;
  margin-bottom: 20px;
}

.input-item {
  display: flex;
  margin-bottom: 12px;
}

.input-item label {
  margin: 0 10px;
  width: 60px;
  background-color: #fff229;
  color: #222;
  padding: 6px 10px;
  border-radius: 4px;
  margin-right: 8px;
  text-align: center;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.input-item input {
  margin: 0 10px;
  flex: 1;
  height: 30px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-left: none;
  border-radius: 4px;
  font-size: 14px;
}

.input-item input:focus {
  outline: none;
  border-color: #fff229;
}

.action-btns {
  text-align: center;
  margin-top: 20px;
}

.action-btns button {
  margin: 0 10px;
  padding: 8px 16px;
  background-color: #fff229;
  color: #222;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.action-btns button:hover {
  background-color: #f0f0f0;
}

.operation-tips {
  margin-top: 20px;
  font-size: 14px;
}

.operation-tips ol {
  list-style-type: decimal;
  margin-left: 20px;
  line-height: 24PX;
}
.operation-tips ol li {
  margin-bottom: 8px;
}
</style>
  